import axios from "axios";

const AI_REQUEST_TIMEOUT = 45000;
const HISTORY_LIMIT = 10;

const unwrap = (response) => {
  const payload = response?.data;
  if (payload && typeof payload === "object" && payload.data && Object.keys(payload).length === 1) {
    return payload.data;
  }
  return payload || {};
};

const getAuthHeaders = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const token = user?.refresh_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};

const getRequestConfig = () => ({
  headers: getAuthHeaders(),
  timeout: AI_REQUEST_TIMEOUT
});

export const getAssistantText = (payload) => {
  if (typeof payload === "string") return payload;
  return (
    payload.reply ||
    payload.answer ||
    payload.content ||
    payload.message ||
    payload.msg ||
    payload.response ||
    ""
  );
};

export const askEvivesomaAI = async ({ mode, message, history }) => {
  const safeHistory = (Array.isArray(history) ? history : [])
    .filter(
      (item) =>
        ["user", "assistant"].includes(item?.role) &&
        typeof item?.content === "string" &&
        item.content.trim()
    )
    .slice(-HISTORY_LIMIT)
    .map((item) => ({ role: item.role, content: item.content.slice(0, 4000) }));

  const response = await axios.post(
    "ai/assistant",
    { mode, message, history: safeHistory },
    getRequestConfig()
  );
  return unwrap(response);
};

export const confirmEvivesomaAIAction = async (confirmationToken) => {
  const response = await axios.post(
    "ai/assistant/confirm",
    { confirmationToken },
    getRequestConfig()
  );
  return unwrap(response);
};

export const getAIErrorMessage = (error) => {
  if (
    (typeof navigator !== "undefined" && !navigator.onLine) ||
    error?.offline ||
    error?.code === "OFFLINE_CACHE_MISS"
  ) {
    return "Evivesoma IA nécessite une connexion Internet.";
  }

  const status = error?.response?.status;
  const apiMessage = error?.response?.data?.msg || error?.response?.data?.message;

  if (apiMessage) return apiMessage;
  if (status === 401) return "Votre session a expiré. Reconnectez-vous pour utiliser Evivesoma IA.";
  if (status === 403) return "Confirmation refusée, expirée ou non autorisée.";
  if (status === 409) return "Cette action a déjà été confirmée.";
  if (status === 422) return "Cette demande nécessite trop d’étapes. Essayez de la simplifier.";
  if (status === 502) return "Le fournisseur IA a retourné une réponse invalide.";
  if (status === 503) return "Le fournisseur IA n’est pas encore configuré.";
  if (status === 504 || error?.code === "ECONNABORTED") {
    return "Le fournisseur IA met trop de temps à répondre. Réessayez.";
  }

  return error?.message || "Evivesoma IA est momentanément indisponible.";
};
